import Tooltip from '@mui/material/Tooltip';

import { ProModeSlider } from "../../ProModeSlider/ProModeSlider"
import { InfoCircle } from "../../SVGasComponent"

import styles from "./proSliderBlock.module.scss";

export const ProSliderBlock = () => {
    return (

        <div className={styles.main}>
            <ProModeSlider />
            <Tooltip title="Для переключения в профессиональный интерфейс" arrow placement="bottom"  >
                <div className={styles.main_svgDiv}>
                    <InfoCircle />
                </div>
            </Tooltip>
        </div>

    )
}